<template>
  <div
    class="tables-settings-table"
    :class="{
      empty: empty,
    }"
  >
    <m-confirm
      ref="confirm"
      confirm="Удалить"
      reset="Отменить"
      mode="danger"
      title="Удаление настройки таблицы"
    ></m-confirm>

    <loader v-if="!inited" label="Данные загружаются" :active="!inited" height="300"></loader>

    <div v-if="inited">
      <div class="desktop">
        <scrolled-table v-if="empty || items.length" @nextPage="nextPage">
          <table class="h-table">
            <thead>
              <tr>
                <th class="table-type">
                  <div class="h-table__col-title" :class="{ active: sortBy === 'name' }" @click="$emit('sort', 'name')">
                    Тип таблицы
                  </div>
                </th>
                <th class="table-columns">Столбцы по умолчанию</th>
                <th width="70" class="table-conditions">
                  <div
                    class="h-table__col-title"
                    :class="{ active: sortBy === 'countConditions' }"
                    @click="$emit('sort', 'countConditions')"
                  >
                    Условия
                  </div>
                </th>
                <th class="table-actions" width="70"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td valign="top">{{ item.name }}</td>
                <td valign="top">
                  <span>
                    <span v-for="(column, i) in item.columns.slice(0, 15)" :key="i" class="column-name">{{
                      column.name
                    }}</span>
                    <transition name="fade">
                      <span v-if="item.opened">
                        <span v-for="(column, i) in item.columns.slice(15)" :key="i" class="column-name">{{
                          column.name
                        }}</span>
                      </span>
                    </transition>
                  </span>

                  <a
                    v-if="item.columns.length > 15 && !item.opened"
                    href="javascript:void(0)"
                    class="table-settings__toggler"
                    @click="$set(item, 'opened', true)"
                  >
                    все
                  </a>
                  <a
                    v-if="item.columns.length > 15 && item.opened"
                    href="javascript:void(0)"
                    class="table-settings__toggler"
                    @click="$set(item, 'opened', false)"
                  >
                    свернуть
                  </a>
                </td>
                <td valign="top" align="right">{{ item.countConditions }}</td>
                <td valign="top">
                  <div class="table-settings__actions">
                    <c-button-2
                      v-b-popover.hover.blur.top="'Редактировать'"
                      class="table-settings__edit"
                      size="iconic"
                      icon="edit"
                      @click="toTableSettings(item)"
                    />
                    <c-button-2
                      v-b-popover.hover.blur.top="'Удалить'"
                      class="table-settings__remove"
                      size="iconic"
                      :icon="{ icon: 'trash', color: 'secondary' }"
                      @click="removeTableSettings(item)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </scrolled-table>

        <loader v-if="loading" label="Данные загружаются" :active="loading" height="300"></loader>
      </div>

      <div class="mobile-wrapper">
        <div v-if="items.length" class="mobile">
          <horizontal-table @nextPage="$emit('nextPage')">
            <table class="h-table">
              <tbody>
                <tr>
                  <th valign="top">
                    <div
                      class="h-table__col-title"
                      :class="{ active: sortBy === 'section' }"
                      @click="$emit('sort', 'section')"
                    >
                      Тип&nbsp;таблицы
                    </div>
                  </th>
                  <td v-for="item in items" :key="item.id" valign="top">
                    {{ item.name }}
                  </td>
                </tr>
                <tr>
                  <th valign="top">Столбцы по умолчанию</th>
                  <td v-for="item in items" :key="item.id" valign="top">
                    <span>
                      <span v-for="(column, i) in item.columns.slice(0, 15)" :key="i" class="column-name">{{
                        column.name
                      }}</span>
                      <transition name="fade">
                        <span v-if="item.opened">
                          <span v-for="(column, i) in item.columns.slice(15)" :key="i" class="column-name">{{
                            column.name
                          }}</span>
                        </span>
                      </transition>
                    </span>

                    <a
                      v-if="item.columns.length > 15 && !item.opened"
                      href="javascript:void(0)"
                      class="table-settings__toggler"
                      @click="$set(item, 'opened', true)"
                    >
                      все
                    </a>
                    <a
                      v-if="item.columns.length > 15 && item.opened"
                      href="javascript:void(0)"
                      class="table-settings__toggler"
                      @click="$set(item, 'opened', false)"
                    >
                      свернуть
                    </a>
                  </td>
                </tr>
                <tr>
                  <th valign="top">
                    <div
                      class="h-table__col-title"
                      :class="{ active: sortBy === 'countConditions' }"
                      @click="$emit('sort', 'countConditions')"
                    >
                      Условия
                    </div>
                  </th>
                  <td v-for="item in items" :key="item.id" valign="top">
                    {{ item.countConditions }}
                  </td>
                </tr>
                <tr>
                  <th valign="top"></th>
                  <td v-for="item in items" :key="item.id" valign="top">
                    <div class="table-settings__actions">
                      <c-button-2
                        v-b-popover.hover.blur.top="'Редактировать'"
                        class="table-settings__edit"
                        size="iconic"
                        icon="edit"
                        @click="toTableSettings(item)"
                      />
                      <c-button-2
                        v-b-popover.hover.blur.top="'Удалить'"
                        class="table-settings__remove"
                        size="iconic"
                        :icon="{ icon: 'trash', color: 'secondary' }"
                        @click="removeTableSettings(item)"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </horizontal-table>
        </div>
        <loader
          v-if="loading"
          class="tables-settings-table__loader"
          label="Данные загружаются"
          :active="loading"
          height="300"
        ></loader>
      </div>

      <div v-if="empty" class="tables-settings-table__empty">Настроек для таблиц пока не добавлено</div>

      <div v-if="!empty && !loading && !items.length" class="tables-settings-table__not-found">
        Ничего не найдено. Попробуйте изменить параметры поиска.
      </div>
    </div>
  </div>
</template>

<script>
import ScrolledTable from "@/components/scrolled-table";
import HorizontalTable from "@/components/horizontal-table";
import Button2 from "@/components/controls2/Button";
import Loader from "@/components/loader";
import MConfirm from "@/components/modals/confirm-modal";

export default {
  name: "tables-settings-table",
  components: {
    ScrolledTable,
    HorizontalTable,
    Loader,
    MConfirm,
    "c-button-2": Button2,
  },
  props: ["inited", "empty", "loading", "sortBy", "items"],
  methods: {
    toTableSettings(table) {
      this.$router.push({
        name: "edit-table-settings",
        params: {
          id: table.id,
        },
      });
    },
    removeTableSettings(table) {
      this.$refs.confirm.open({
        text: `Настройка таблицы <b>${table.name}</b> будет удалена без возможности восстановления`,
        onConfirm: () => {
          this.$emit("remove", table);
        },
      });
    },
    nextPage() {
      if (this.inited) {
        this.$emit("nextPage");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.tables-settings-table {
  &__empty {
    background: white;
    font-size: 15px;
    color: #8e9cbb;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    border: 1px solid #dfe4ef;
    margin-top: -14px;
  }

  &__not-found {
    font-size: 15px;
    color: #8e9cbb;
    padding-top: 12px;
  }

  .table-settings {
    &__actions {
      display: flex;
    }
    &__edit {
      margin-left: 2px;
      margin-right: 10px;
      margin-top: 2px;
    }
    &__toggler {
      text-decoration: none;
      margin-left: 4px;
    }
  }

  .table-columns {
    width: 100%;
  }

  .table-actions {
    min-width: 70px;
  }

  .column-name {
    display: inline-flex;
    margin-right: 4px;
  }

  .column-name:not(:last-child) {
    &:after {
      content: ",";
    }
  }

  .desktop {
    th:first-child {
      min-width: 300px;
    }
  }

  .mobile-wrapper {
    display: none;
    position: relative;
  }

  .mobile + &__loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: auto;
    opacity: 0.8;
  }

  @include mobileAndTablet {
    .desktop th:first-child {
      min-width: 100px;
    }
  }

  @include onlyStandartMobile {
    .mobile-wrapper {
      display: block;
      margin-left: -21px;
      margin-right: -21px;
    }
    .mobile {
      th {
        min-width: 100px;
        max-width: 100px;
        width: 100px;
        vertical-align: top;
      }

      td {
        min-width: calc(100vw - 100px);
      }
    }
    .desktop {
      display: none;
    }
    &__empty {
      margin-left: -21px;
      margin-right: -21px;
      margin-top: 0;
    }
    &.empty {
      .mobile {
        display: none;
      }
    }
  }
}
</style>
